import request from '../request'
import { objectToQueryString } from '../../components/Dashboard/DataEntry/helpers/objectToQueryString'

export const getAssessments = (skip = 0, limit = 50, filter, active = true) =>
  request
    .get(
      `/data-entry/assessments?skip=${skip}&limit=${limit}&active=${active}&${objectToQueryString(filter)}`
    )
    .then((res) => res)

export const getAssessmentMarking = (assessmentId = '', skip = 0, limit = 50, filter = {}) =>
  request
    .get(
      `/data-entry/marking/assessment/${assessmentId}?skip=${skip}&limit=${limit}&${objectToQueryString(
        filter
      )}`
    )
    .then((res) => res)

// Dedicated export endpoint: returns ALL marking records (batched server-side,
// no 16MB group) — use for CSV export instead of a huge limit on the paginated one.
export const getAssessmentMarkingExport = (assessmentId = '', filter = {}) =>
  request
    .get(`/data-entry/marking/assessment/${assessmentId}/export?${objectToQueryString(filter)}`)
    .then((res) => res)

export const getClassesByUser = () =>
  request.get(`/data-entry/assessments/classes-by-teacher`).then((res) => res)

export const getStudentsForAssessment = (skip = 0, limit = 50, filter = {}) =>
  request.post(`/data-entry/assessments/students?skip=${skip}&limit=${limit}`, filter).then((res) => res)

// MF-532: ids del set filtrado (para "select all"), pedidos on-demand.
export const getStudentIdsForAssessment = (filter = {}) =>
  request.post(`/data-entry/assessments/students/ids`, filter).then((res) => res)

export const getClassesForAssessment = (filter = {}) =>
  request.get(`/data-entry/assessments/classes?${objectToQueryString(filter)}`).then((res) => res)

export const getFullAssessmentData = (assessmentId = '', filter = {}) =>
  request
    .get(`/data-entry/assessments/${assessmentId}/full?${objectToQueryString(filter)}`)
    .then((res) => res)

export const deleteAssessment = (assessmentId = '') =>
  request.delete(`/data-entry/assessments/${assessmentId}`).then((res) => res)

export const createAssessment = (data) => request.post(`/data-entry/assessments`, data).then((res) => res)

export const cloneAssessment = (assessmentId = '', data) =>
  request.post(`/data-entry/assessments/${assessmentId}/clone`, data).then((res) => res)

export const assessmentMarkingBulk = (data) =>
  request.put(`/data-entry/marking/bulk`, data).then((res) => res)

// MF-399 — finaliza un round (status=finalized). Los charts/analytics solo
// consideran rounds finalizados.
export const finalizeAssessmentRound = (assessmentId = '', roundId = '') =>
  request.patch(`/data-entry/assessments/${assessmentId}/rounds/${roundId}/finalize`).then((res) => res)

// MF-399 — reabre (des-finaliza) un round para retomar el marcado.
export const reopenAssessmentRound = (assessmentId = '', roundId = '') =>
  request.patch(`/data-entry/assessments/${assessmentId}/rounds/${roundId}/reopen`).then((res) => res)

export const updateAssessment = (assessmentId = '', data) =>
  request.put(`/data-entry/assessments/${assessmentId}`, data).then((res) => res)

export const getAssessmentNameTaken = (name = '', assessmentId = '') =>
  request
    .get(`/data-entry/assessments/check-name/${name}${assessmentId ? `?assessmentId=${assessmentId}` : ''}`)
    .then((res) => res)
